export const getAssurances = (state) => state.assuranceReducer.assurance;
export const isSuccess = (state) => state.assuranceReducer.isSuccess;
export const isLoading = (state) => state.assuranceReducer.isLoading;
export const isError = (state) => state.assuranceReducer.isError;
